import React from 'react';
import { BsLinkedin, BsInstagram, BsGithub } from 'react-icons/bs';
import { FaRobot } from 'react-icons/fa';
import { images } from '../constants'

const SocialMedia = () => {
  return (
    <div className="app__social">
        <div>
          <a href="https://www.linkedin.com/in/austin-wheeler-a84132248/">
            <BsLinkedin />
          </a>
        </div>
        <div>
          <a href="https://github.com/AustinWheel">
            <BsGithub />
          </a>
        </div>
        <div>
          <a href="http://ddihts.com/">
          <FaRobot />
          </a>
        </div>
    </div>
  )
}

export default SocialMedia